export default {
  NEW_CARD: 'PAYMENT_CATEGORY_NEW_CARD',
  EXPRESS_PAYMENTS: 'PAYMENT_CATEGORY_EXPRESS_PAYMENTS',
  PAY_LATER: 'PAYMENT_CATEGORY_PAY_LATER',
};
